var _excluded = ["entity"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import config from 'react-global-configuration';
import c from 'classnames';
import { FormAddressAutocomplete } from '@uncinc/uncinc-react-kitchen-sink';
var WebformDutchAddressAutocomplete = function WebformDutchAddressAutocomplete(props) {
  var entity = props.entity,
    fieldProps = _objectWithoutProperties(props, _excluded);
  var API_URL = config.get('API_URL');
  var webform = entity.toJS();
  var wrapperClassNames = c('WebformDutchAddressAutocomplete', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  var title = webform['#title'];
  var webformKey = webform['#webform_key'];
  var elements = webform['#webform_composite_elements'];
  var postcode = elements.postcode;
  var housenumber = elements.housenumber;
  var extension = elements.housenumber_extension;
  var street = elements.street;
  var city = elements.city;
  var country = elements.country;
  return /*#__PURE__*/React.createElement("div", {
    id: webformKey,
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(FormAddressAutocomplete, _extends({}, fieldProps, {
    title: title,
    description: webform['#description'],
    descriptionAboveInput: webform['#description_display'] !== 'after',
    fieldName: webformKey,
    fieldNamePostcode: "postcode",
    fieldNameHousenumber: "housenumber",
    fieldNameExtension: "housenumber_extension",
    fieldNameStreet: "street",
    fieldNameCity: "city",
    fieldNameCountry: "country",
    descriptionPostcode: postcode['#description'],
    descriptionHousenumber: housenumber['#description'],
    descriptionExtension: extension['#description'],
    descriptionStreet: street['#description'],
    descriptionCity: city['#description'],
    descriptionCountry: country['#description'],
    placeholderPostcode: postcode['#placeholder'],
    placeholderHousenumber: housenumber['#placeholder'],
    placeholderExtension: extension['#placeholder'],
    placeholderStreet: street['#placeholder'],
    placeholderCity: city['#placeholder'],
    placeholderCountry: country['#placeholder'],
    countryOptions: country['#access'] === false ? null : country['#options'],
    endpoint: "".concat(API_URL, "/api/address-autocomplete")
  })));
};
export default WebformDutchAddressAutocomplete;